import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { SimpleErrorDialog } from "../../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../../controls/successMessageControl";
import { LS2PAC_Utils } from "../../utils/Utils";
import { ResourceUtils } from "../../utils/resourceUtils";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BatchDialogView } from "../BatchDialogView";

export class MyAccountBaseSubView extends BatchDialogView {
  constructor(options) {
    options = options || {};
    options.toggleButtonClass = "toggleButton";
    super(options);

    this.id = options.id;
    this.navigationId = options.parentId + "_nav";
    this.tabId = this.id + "_tab";
    this.tabCountId = this.tabId + "_count";
    this.noItemsId = this.id + "_noItems";
    this.itemsContainerId = this.id + "_itemsContainer";
    this.itemsId = this.id + "_items";
    this.sortId = this.id + "_sort";
    this.countField = options.countField;
    this.hasBoundEvents = false;
    this.viewName = options.viewName;
    this.template = options.template;
    this.itemsTemplate = options.itemsTemplate;
    this.tabText = options.tabText;
    this.dataFieldName = options.dataFieldName;
    this.currentUser;
    this.accountSummary = null;
    this.clientManager = this.getClientManager(options);
    this.hasBoundEvents = false;
    this.dataToSendToTemplate = options.dataToSendToTemplate;
    this.sortOptions = options.sortOptions;
    this.addBookJackets = options.addBookJackets;
    this.bookJacektIdSuffix = options.bookJacektIdSuffix;
    this.ratingsSuffix = options.ratingsSuffix;
    this.countId = options.countId;
    this.parentClass = options.parentClass;
    this.hasEvents = false;
    this.addInternalListeners();
  }
  getClientManager() {
    return null;
  }
  load(
    accountSummary,
    currentUser,
    contentContainer,
    currentView,
    index,
    needsToForceANewView
  ) {
    var _this = this;
    this.accountSummary = accountSummary;
    this.currentUser = currentUser;
    this.contentContainer = contentContainer;

    if (this.loadIfTrue(currentView)) {
      if ($("#" + this.id).length == 0) {

        TemplateEngine.fetch(
          this.template,
          this.contentContainer,
          {
            id: this.id,
            sortOptions: this.sortOptions,
            data: this.dataToSendToTemplate || "",
            user: this.currentUser,
            patron: this.accountSummary.patron
          },
          function () {
            _this.handleViewState(currentView, index, needsToForceANewView);
            _this.addEventsOneTime();
          }
        );
      } else {
        $("#" + this.itemsId).empty();
        $("#" + this.id)
          .find("input.showMore")
          .hide();
        _this.handleViewState(currentView, index, needsToForceANewView);
      }
    }
  }
  loadIfTrue() {
    return true;
  }
  isGuardian() {
    const useGuardianProhibition =
      ApplicationData.supportedFunctionality.useGuardianProhibition;
    const hasChildren = this.accountSummary?.patron?.children?.length > 0;
    return useGuardianProhibition && hasChildren;
  }
  handleViewState(currentView, index, needsToForceANewView) {
    this.uncheckSelectAll();
    this.toggleButtonsBasedOnCheckboxes();
    if (this.accountSummary.patron) {
      this.setSideTabCount(this.accountSummary.patron[this.countField]);
    }

    if (
      needsToForceANewView ||
      currentView == this.viewName ||
      (!currentView && index == 0)
    ) {
      //|| (!currentView && this.isDefaultView())) {
      $("#" + this.id).show();
      $("#" + this.tabId).addClass("disabled hilite");
      var container = $("#" + this.itemsContainerId);
      container.show();
      if (window.isIE8 == false) {
        container.spin({ lines: 10, length: 8, width: 4, radius: 8, top: 80 });
      }
      this.preItemLoad();
      this.pageData = null;
      this.postInitialLoad();
      this.fetchData();
    } else {
      $("#" + this.id).hide();
      $("#" + this.tabId).removeClass("disabled hilite");
    }
  }
  setSideTabCount(count) {
    if (this.countField) {
      $("#" + this.tabCountId).html(count);
    }
  }
  //meant to be overriden
  addListeners() {}

  responseEventHandler() {
    var _this = this;
    return function (event) {
      _this.updateUI(
        event.data[_this.dataFieldName] !== undefined &&
          event.data[_this.dataFieldName].length > 0
          ? 1
          : 0
      );

      if (_this.pageData == null) {
        _this.pageData = event.data;
      } else {
        var list = _this.pageData[_this.dataFieldName];
        _this.pageData[_this.dataFieldName] = list.concat(
          event.data[_this.dataFieldName]
        );
      }
      _this.setShowMoreDisplay(event.data.nextEnabled);
      _this.handleDataResponse(event.data);
    };
  }
  setShowMoreDisplay(nextEnabled) {
    if (nextEnabled == false) {
      $("#" + this.id)
        .find("input.showMore")
        .hide();
    } else {
      $("#" + this.id)
        .find("input.showMore")
        .removeClass(LS2PAC_CONSTANTS.CssClasses.disabled)
        .show();
    }
  }
  addInternalListeners() {
    if (this.clientManager) {
      //TODO this won't work for multiple clientManagers, use a check function instead
      this.addListener(this.clientManager.responseEvent, this.responseEventHandler());
    }

    this.addListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, (event) => {
      this.pageData = null;
      if (this.clientManager) {
        $("#" + this.sortId).val(this.clientManager.defaultSort);
      }
      $("#" + this.itemsId).empty();
      $("#" + this.noItemsId).hide();
      this.setSideTabCount("");
      this.handleLogout();
    });

    this.addListeners();
  }
  postInitialLoad() {}
  handleLogout() {}
  updateUI(length) {
    if (!length || length == 0) {
      $("#" + this.itemsContainerId).hide();
      $("#" + this.noItemsId).show();
    } else {
      $("#" + this.itemsContainerId).show();
      $("#" + this.noItemsId).hide();
    }
  }
  /* helper function meant to be overriden, some data elements have to be changed to make displaying easier */
  manipulateData() {}
  handleDataResponse(data) {
    $("#" + this.itemsContainerId).spin(false);
    if (!data) {
      $("#" + this.itemsId).empty();
    }
    data = data || this.pageData;
    TLCLogger.log("data", data);
    var _this = this;
    var itemData = data[this.dataFieldName];
    //this is to do any conversion on the data before the template (if it needs it)
    this.manipulateData();

    TemplateEngine.fetch(
      this.itemsTemplate,
      this.itemsId,
      data[this.dataFieldName],
      function () {
        _this.handleBookJackets(data);
        _this.postItemLoad(itemData);
      }
    );
  }
  handleBookJackets(data) {
    var _this = this;
    if (_this.addBookJackets) {
      $.each(data[_this.dataFieldName], function (index, item) {
        var resource = item.resource === undefined ? item : item.resource;
        if (resource) {
          $("#" + item.id + _this.bookJacektIdSuffix).addCoverArt(
            LibraryThing.enums.requestType.bookJacketSmall,
            [resource],
            0,
            true,
            true
          );
          // if (resource.ratingInformation && resource.rtype === 1) {
            
          // }
        }
      });
    }
  }
  /* usually called after some action has been taken on the data and it needs to be refreshed */
  updateAccountData() {
    console.log("updateAccountData called");
    this.clearResults();
    this.setAllCheckboxes(false);
    AccountHolder.fetchAccountSummaryAndPatron(true);
  }
  afterResponseRendered() {}
  preItemLoad() {}
  postItemLoad() {}
  handleBatchFeedback(event, batchErrorMessage, successMessage) {
    var _this = this;

    if (event.success) {
      if (event.data && event.data.length == 1) {
        var response = event.data[0];
        if (response.messageToken) {
          var message = ResourceUtils.getMessageByMessageTokenString(
            response.messageToken
          );
          if (response.success) {
            successMessage = message;
          } else {
            batchErrorMessage = message;
          }
        }
      }

      //TODO: Kos - add failure specific messaging -- currently only applies to mackin eBooks...
      // var successfulItems = [];
      // var errors = [];
      //
      // $.each( event.data, function( i, loanInfo ) {
      // 	if( loanInfo.success === true ) {
      // 		successfulItems.push( loanInfo );
      // 	}
      // 	else {
      // 		errors.push( loanInfo );
      // 	}
      // } );
      // if ( errors.length > 1 ) {
      this.openBatchDialog(
        {
          event: event,
          batchErrorMessage: batchErrorMessage,
        },
        function (successfulItems) {
          _this.handleSuccessMessage(successfulItems, successMessage);
        }
      );
      // } else {
      // 	if (errors.length > 0){
      // 		if( event.onHoldForAnotherUser ) {
      // 			SimpleErrorDialog.show( ApplicationData.language.eResourceLoanIsOnHold );
      // 		} else if( event.renewalsNotAllowed ) {
      // 			SimpleErrorDialog.show( ApplicationData.language.eResourceLoanRenewalNotPermitted );
      // 		} else if( event.maxedOut ){
      // 			SimpleErrorDialog.show( ApplicationData.language.PatronCannotCheckoutTitleToken );
      // 		} else if( event.allCopiesOnHold ) {
      // 			SimpleErrorDialog.show( ApplicationData.language.eResourceAllCopiesOnHold );
      // 		}
      // 	}
      //
      // 	if (successfulItems.length > 0){
      // 		_this.handleSuccessMessage( successfulItems, successMessage );
      // 	}
      // }
    } else {
      //TODO: kos - something bad happened.
      SimpleErrorDialog.show("something bad happened");
    }
  }
  handleSuccessMessage(successfulItems, successMessage) {
    if (successfulItems.length == 0) {
      return;
    }
    SuccessMessageControl.show(`${successfulItems.length} ${successMessage}`);
    //this is to update the UI in anyway need after the success message is displayed.
    //it might be as simple as re-requesting data
    this.handleSuccessState(successfulItems);
  }
  //override if necessary
  handleSuccessState() {}
  clearResults() {
    $("#" + this.itemsId).empty();
  }
  addEventsOneTime() {
    var _this = this;
    if (this.hasBoundEvents == false) {
      this.addEvents();

      this.setupCheckboxDelegation();
      this.addEventHandler($("#" + this.id), "click", "input.showMore", (event) => {
        TLCLogger.log("show more", this.clientManager);
        $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
        TLCEventManager.fireEvent(this.clientManager.nextPageEvent);
        return false;
      });

      // this.addEventHandler($("#" + _this.id), "click", ".allCopies", (event) => {
      //   this.goToDetailsPage(event, LS2PAC_CONSTANTS.DetailPages.allCopies);
      //   return false;
      // });

      // this.addEventHandler($("#" + _this.id), "click", ".reviews", (event) => {
      //   this.goToDetailsPage(event, LS2PAC_CONSTANTS.DetailPages.reviews);
      //   return false;
      // });

      this.addEventHandler($("#" + _this.id), "change", "#" + this.sortId, (event) => {
        this.pageData = null;
        this.clearResults();
        this.clientManager.sort({ sortField: event.currentTarget.value });
      });

      this.hasBoundEvents = true;
    }
  }
  goToDetailsPage(event, viewName) {
    // debugger;
    // TODO for the morning, why do we need this vs. just a resource URL?
    var resource = this.getResourceFromDataItem(
      this.getDataItemFromIndex($(event.currentTarget))
    );

    if (resource) {
      var data = LS2PAC_Utils.getFakePagingDataToSendToFullDetails([
        this.getResourceFromDataItem(
          this.getDataItemFromIndex($(event.currentTarget))
        ),
      ]);
      data.viewName = viewName || LS2PAC_CONSTANTS.DetailPages.fullDetails;
      TLCEventManager.fireEvent(
        LS2PAC_CONSTANTS.Events.onShowFullDetails,
        data
      );
    }
  }
  getResourceFromDataItem(dataItem) {
    return dataItem.resource;
  }
  addEvents() {}
  fetchData() {}
}
